export default __webpack_public_path__ + "static/media/english-to-russian-screenshot-02.9176662f.png";